<template>
    <div id="marquee" :class="color">
        <div class="marquee3k">
            <span>
                <span class="">#BLEACHHAIRPARTY</span>
            </span>
        </div>
    </div>  
            
</template>

<script>

export default {
    data: function(){
        return{
             animationId: 0
        };
    },
    props: {
        color: {
            type: String,
            default: "white bottom"
        }
    },
    mounted(){
        this.init();
    },
    //Ported from https://github.com/ezekielaquino/Marquee3000
    methods: {
        init: function() {
            if (this.animationId) window.cancelAnimationFrame(this.animationId);

            this.marquee = Array.from(document.querySelectorAll('.marquee3k'))[0];
            this.previousWidth = window.innerWidth;
            this.timer;

            this.instance = this.reinit(
                this.marquee,
                    {
                        selector: 'marquee3k',
                        reverse: false
                    }
                );

            this.animateGlobal();
            window.addEventListener('resize', () => {
                clearTimeout(this.timer);
    
                this.refireSize();
            });

        },
        refireSize: function() {
                clearTimeout(this.timer);
                this.timer = setTimeout(function() {
                    this.isLarger = this.previousWidth < window.innerWidth;
                    this.difference = window.innerWidth - this.previousWidth;

                    this.repopulate(this.difference, this.isLarger);
                
                    this.previousWidth = window.innerWidth;
                    console.log("refireSize", this)
                }.bind(this), 250);
        },
        animateGlobal: function() {
            this.animate();
            this.animationId = window.requestAnimationFrame(this.animateGlobal);
        },
        reinit: function(element, options) {
            this.element = element;
            this.selector = options.selector;
            this.speed = 0.55;
            this.reverse = false;
            this.parent = element.parentElement;
            this.parentProps = this.parent.getBoundingClientRect();
            this.content = element.children[0];
            this.innerContent = this.content.innerHTML;
            this.wrapStyles = '';
            this.offset = 0;
            this._setupWrapper();
            this._setupContent();
            this.wrapper.appendChild(this.content);
            this.element.appendChild(this.wrapper);

            this.refireSize();
        },
        _setupWrapper() {
            this.wrapper = document.createElement('div');
            this.wrapper.classList.add('marquee3k__wrapper');
            this.wrapper.style.whiteSpace = 'nowrap';
        },
        _setupContent() {
            this.content.classList.add(`${this.selector}__copy`);
            this.content.style.display = 'inline-block';
            this.contentWidth = this.content.offsetWidth;

            this.requiredReps = this.contentWidth > this.parentProps.width ? 2 : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1;

            for (let i = 0; i < this.requiredReps; i++) {
                this._createClone();
            }

            
            if (this.reverse) {
                this.offset = this.contentWidth * -1;
            }

            this.element.classList.add('is-init');
        },
        _createClone() {
            const clone = this.content.cloneNode(true);
            clone.style.display = 'inline-block';
            clone.classList.add(`${this.selector}__copy`);
            this.wrapper.appendChild(clone);
        },
        animate() {
            if (!this.paused) {
                const isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1;
                const direction = this.reverse ? -1 : 1;
                const reset = this.reverse ? this.contentWidth * -1 : 0;

                if (isScrolled) this.offset -= this.speed * direction;
                else this.offset = reset;

                this.wrapper.style.whiteSpace = 'nowrap';
                this.wrapper.style.transform = `translate(${this.offset}px, 0) translateZ(0)`;
            }
        },
        _refresh() {
            this.contentWidth = this.content.offsetWidth;
        },
        repopulate(difference, isLarger) {
            this.contentWidth = this.content.offsetWidth;

            if (isLarger) {
                const amount = Math.ceil(difference / this.contentWidth) + 1;

                for (let i = 0; i < amount; i++) {
                    this._createClone();
                }
            }
        },

    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$white: #FFF;
$black: #000;
$green:#88FEC0;
$pink: #EDD4DF;
$break-large: 720px;
     .marquee3k .is-init {
            background: red;
    }
#marquee {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    letter-spacing: 0.2px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 5px 0;
    overflow: hidden;
        &.white {
            background: $white;
            color: $green;
        }
        &.black {
            background: $black;
            color: $white;    
        }
        &.top  {
            bottom: auto;
            top: 0;
        }
        &.bottom {
            bottom: 0;
            top: auto;
        }

        .padding {
            padding: 0 20px;
        }
        @media screen and (max-width: $break-large) { 
            &.mobile-top {
                bottom: auto;
                top: 0;
            }
        }
        .marquee3k__copy {
            padding: 0 20px;
            display: block;
        }

}
</style>
